import Axios from 'axios';
 
const USER = '/user';
 
export default {
    
  getUserByVendorId(id) {
    return Axios.get(`${USER}/getUserByVendorId/${id}`);
  },
  
  getAll() {
    return Axios.get(USER);
  },
 
  get(id) {
    return Axios.get(`${USER}/${id}`);
  },
 
  create(data) {
    return Axios.post(USER, data);
  },
 
  update(id, data) {
    return Axios.put(`${USER}/${id}`, data);
  },
 
  delete(id) {
    return Axios.delete(`${USER}/${id}`);
  },


};